import { useState, useEffect } from "react";
import { ArrowLeft, Share2, FileText, X, Upload, Plus } from "lucide-react";
import AppointmentDetails from "../../Component/AppointmentDetail/AppointmentDetails";
import FollowUpDialog from "../../Component/AppointmentDetail/FollowUpDialog";
import Sidebar from "../../Component/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppointmentCounter,
  getAppointmentDetailData,
} from "../../redux/action/Appointment";
import IMAGES from "../../constants/images";
import RescheduleModal from "./RescheduleModal";
import axios from "axios";
import { message } from "antd";
import { navigateTo, getPathSegment, getFullPath } from "../../utils/navigation";

export default function AppointmentPage() {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);

  const { data, loading } = useSelector((state) => state.APPOINTMENT_COUNTER);
  const { detail, detailLoading, detailError } = useSelector(
    (state) => state.GET_APPOINTMENT_DETAIL
  );

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [aid, setAid] = useState(getPathSegment(2));
  const [uid, setUid] = useState(getPathSegment(3));
  const [showModal, setShowModal] = useState(false);
  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [detailData, setDetailData] = useState({});
  const [myAppointment, setMyAppointment] = useState([]);
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handlePDFExport = () => {
    // Open member summary report page in a new tab with appointment parameters
    window.open(getFullPath(`/member-summary-report/${aid}/${uid}`), '_blank');
  };

  const getAppointmentData = () => {
    const payload = {};
    dispatch(getAppointmentCounter(payload));
  };

  const filterAllData = () => {
    const allAppointments = Object.values(data).flat().filter(Boolean);

    if (allAppointments.length > 0) {
      let details = allAppointments.filter(
        (item) => item.appointmentId === aid
      );
      let my = allAppointments.filter((item) => item.uid === parseInt(uid));

      setDetailData(details[0]);
      getBasicInfo(details[0].appointmentId);
      setMyAppointment(my);
    }
  };

  const handleConfirm = () => {
    setShowModal(false);
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };
    let response = axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/appointment/reschedule/${aid}`,
        config
      )
      .then((res) => {
        console.log("response==========>", res);
        if (res?.status === 200) {
          message.success(res?.data).then(() => {
            window.location.reload();
          });
        } else {
          message.error("Something went wrong");
        }
      });
  };

  const rescheduleApp = () => {
    handleOpen();
  };

  const getBasicInfo = (id) => {
    dispatch(getAppointmentDetailData(id));
  };

  const handleSessionUpdated = () => {
    // Refresh appointment data when a session is updated
    getAppointmentData();
  };

  useEffect(() => {
    getAppointmentData();
  }, []);

  useEffect(() => {
    if (data) {
      filterAllData();
    }
  }, [data]);

  useEffect(() => {
    console.log("detaildetaildetail", detail);
  }, [dispatch, detail, detailLoading]);

  return (
    <div className="flex w-full  bg-[#F8FAFC] min-h-screen  mt-[80px]">
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        <div className="w-full">
          <div className="w-full mx-auto ">
            <div className="bg-white rounded-2xl shadow-sm relative overflow-hidden">
              {/* Header */}
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 px-[16px] py-[12px] border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9]">
                <div className="flex items-center justify-between sm:justify-start gap-4">
                  <button
                    className="p-0 hover:bg-gray-100 rounded-full bg-transparent"
                    onClick={() => {
                      navigateTo("/upcoming-appointments/upcoming");
                    }}
                  >
                    <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5 text-[#171717]" />
                  </button>

                  {/* Close Button - Moved to left side on mobile */}
                  <button
                    className="sm:hidden p-0 hover:bg-gray-100 rounded-full bg-transparent transition-colors"
                    onClick={() => {
                      navigateTo("/upcoming-appointments/upcoming");
                    }}
                  >
                    <X className="h-4 w-4 text-[#171717]" />
                  </button>
                </div>

                <div className="flex flex-wrap items-center gap-2">
                  {/* Export Button */}
                  <button
                    className="flex items-center justify-center w-9 h-9 p-0 bg-[#FFFFFF] rounded-xl shadow-sm hover:bg-gray-50 transition-colors"
                    style={{ border: "1px solid #E2E8F0" }}
                    onClick={handlePDFExport}
                    title="Export to PDF"
                  >
                    <Upload className="h-4 w-4 text-[#2563EB]" />
                  </button>

                  {/* Share Button */}
                  <button
                    className="flex items-center justify-center w-9 h-9 p-0 bg-[#FFFFFF] rounded-xl shadow-sm hover:bg-gray-50 transition-colors"
                    style={{ border: "1px solid #E2E8F0" }}
                  >
                    <Share2 className="h-4 w-4 text-[#2563EB]" />
                  </button>

                  {/* Request Reschedule Button */}
                  <button
                    className="bg-white rounded-xl h-9 px-[12px] py-0 flex items-center gap-1.5 shadow-sm hover:bg-[#F8FAFC] transition-colors"
                    style={{ border: "1px solid #E2E8F0" }}
                    onClick={() => rescheduleApp()}
                  >
                    <img
                      src={IMAGES.request_reschedule}
                      alt="request reschedule"
                      className="w-4 h-4"
                    />
                    <span className="font-poppins text-[14px] font-semibold text-[#171717] whitespace-nowrap">
                      Request Reschedule
                    </span>
                  </button>

                  {/* Create FollowUp Button */}
                  <button
                    className="btn-gradient rounded-xl h-9 px-[12px] py-0 flex items-center gap-1.5 shadow-sm"
                    onClick={openDialog}
                  >
                    <Plus className="h-4 w-4 text-[#FFFFFF]" />
                    <span className="font-poppins text-[14px] font-semibold text-[#FFFFFF] whitespace-nowrap">
                      Create FollowUp
                    </span>
                  </button>

                  {/* Close Button - Hidden on mobile, moved to left side */}
                  <button
                    className="hidden sm:block p-0 hover:bg-gray-100 rounded-full bg-transparent transition-colors"
                    onClick={() => {
                      navigateTo("/upcoming-appointments/upcoming");
                    }}
                  >
                    <X className="h-4 w-4 sm:h-5 sm:w-5 text-[#171717]" />
                  </button>
                </div>
              </div>

              {/* Main Content */}
              <AppointmentDetails
                appointmentId={aid}
                detailData={detailData}
                myAppointment={myAppointment}
                detail={detail}
                onExport={handlePDFExport}
                onSessionUpdated={handleSessionUpdated}
              />
            </div>
          </div>

          {/* Follow Up Dialog */}
          <FollowUpDialog
            open={isDialogOpen}
            onClose={closeDialog}
            clientId={detail?.pcUserId}
          />
        </div>
      </div>
      <RescheduleModal
        isOpen={showModal}
        onCancel={handleClose}
        onConfirm={handleConfirm}
        imageSrc={IMAGES.reschedule_icon}
      />
    </div>
  );
}
